import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { handleModal, handleModalLogin } from 'src/store/actions/modal';
import { isUserLoggedIn } from 'src/utils';
import Modal from 'src/components/reusable/Modal';
import AccountVerified from 'src/components/auth/AccountVerified';
import CheckEmail from 'src/components/auth/CheckEmail';
import Login from 'src/components/auth/Login';
import Register from 'src/components/auth/Register';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const dispatch = useAppDispatch();
  const { open, openLogin, openRegister, openCheckEmail, openAccountVerified } =
    useAppSelector((state) => state.modal);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (!isUserLoggedIn()) {
      if (pathname !== requestedLocation) {
        setRequestedLocation(pathname);
      }
      dispatch(handleModal(true));
      dispatch(handleModalLogin(true));
    } else {
      dispatch(handleModal(false));
    }
  }, [pathname, requestedLocation]);

  const handleClose = () => {
    navigate('/');
    dispatch(handleModal(false));
  };

  if (!isUserLoggedIn()) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return (
      <Modal
        title={openCheckEmail ? 'Check your email' : null}
        isOpen={open}
        closeModal={handleClose}
      >
        {openLogin && <Login />}
        {openRegister && <Register />}
        {openCheckEmail && <CheckEmail />}
        {openAccountVerified && <AccountVerified />}
      </Modal>
    );
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
